import { createAction } from 'redux-act';
// add Ticket action
const createTicketRequest = createAction('CREATE_TICKET_REQUEST', data => data);
const createTicketSuccess = createAction('CREATE_TICKET_SUCCESS', data => data);
const createTicketError = createAction('CREATE_TICKET_ERROR');

// get Ticket action
const getTicketRequest = createAction('GET_TICKET_REQUEST', data => data);
const getTicketSuccess = createAction('GET_TICKET_SUCCESS', data => data);
const getTicketError = createAction('GET_TICKET_ERROR');

// get Ticket  action
const getAllTicketRequest = createAction('GET_ALL_TICKET_REQUEST', data => data);
const getAllTicketSuccess = createAction('GET_ALL_TICKET_SUCCESS', data => data);
const getAllTicketError = createAction('GET_ALL_TICKET_ERROR');

// Update Ticket action
const updateTicketRequest = createAction('UPDATE_TICKET_REQUEST', data => data);
const updateTicketSuccess = createAction('UPDATE_TICKET_SUCCESS', data => data);
const updateTicketError = createAction('UPDATE_TICKET_ERROR');

// Delete Ticket action
const deleteTicketRequest = createAction('DELETE_TICKET_REQUEST', data => data);
const deleteTicketSuccess = createAction('DELETE_TICKET_SUCCESS', data => data);
const deleteTicketError = createAction('DELETE_TICKET_ERROR');

// Create Ticket Issue Type action
const createTicketIssueTypeRequest = createAction('CREATE_TICKET_ISSUE_REQUEST', data => data);
const createTicketIssueTypeSuccess = createAction('CREATE_TICKET_ISSUE_SUCCESS', data => data);
const createTicketIssueTypeError = createAction('CREATE_TICKET_ISSUE_ERROR');

// GET ALL Ticket Type action
const getAllTicketTypeRequest = createAction('GET_ALL_TICKET_TYPE_REQUEST', data => data);
const getAllTicketTypeSuccess = createAction('GET_ALL_TICKET_TYPE_SUCCESS', data => data);
const getAllTicketTypeError = createAction('GET_ALL_TICKET_TYPE_ERROR');

// GET Ticket Issue Sub Type action
const getTicketIssueSubTypeRequest = createAction('GET_TICKET_ISSUE_SUB_TYPE_REQUEST', data => data);
const getTicketIssueSubTypeSuccess = createAction('GET_TICKET_ISSUE_SUB_TYPE_SUCCESS', data => data);
const getTicketIssueSubTypeError = createAction('GET_TICKET_ISSUE_SUB_TYPE_ERROR');

// get All Ticket Issue Type action
const getAllTicketIssueTypeRequest = createAction('GET_ALL_TICKET_ISSUE_TYPE_REQUEST', data => data);
const getAllTicketIssueTypeSuccess = createAction('GET_ALL_TICKET_ISSUE_TYPE_SUCCESS', data => data);
const getAllTicketIssueTypeError = createAction('GET_ALL_TICKET_ISSUE_TYPE_ERROR');

// Update Ticket Type action
const updateTicketTypeRequest = createAction('UPDATE_TICKET_TYPE_REQUEST', data => data);
const updateTicketTypeSuccess = createAction('UPDATE_TICKET_TYPE_SUCCESS', data => data);
const updateTicketTypeError = createAction('UPDATE_TICKET_TYPE_ERROR');


// Delete Ticket Type action
const deleteTicketTypeRequest = createAction('DELETE_TICKET_TYPE_REQUEST', data => data);
const deleteTicketTypeSuccess = createAction('DELETE_TICKET_TYPE_SUCCESS', data => data);
const deleteTicketTypeError = createAction('DELETE_TICKET_TYPE_ERROR');

// add Ticket log action
const createTicketLogsRequest = createAction('ADD_TICKET_LOG_REQUEST', data => data);
const createTicketLogsSuccess = createAction('ADD_TICKET_LOG_SUCCESS', data => data);
const createTicketLogsError = createAction('ADD_TICKET_LOG_ERROR');

// get Ticket log action
const getAllTicketLogsRequest = createAction('GET_ALL_TICKET_LOG_REQUEST', data => data);
const getAllTicketLogsSuccess = createAction('GET_ALL_TICKET_LOG_SUCCESS', data => data);
const getAllTicketLogsError = createAction('GET_ALL_TICKET_LOG_ERROR');

// get Ticket log action
const getTicketLogsRequest = createAction('GET_TICKET_LOG_REQUEST', data => data);
const getTicketLogsSuccess = createAction('GET_TICKET_LOG_SUCCESS', data => data);
const getTicketLogsError = createAction('GET_TICKET_LOG_ERROR');

// Update Ticket log action
const updateTicketLogsRequest = createAction('UPDATE_TICKET_LOG_REQUEST', data => data);
const updateTicketLogsSuccess = createAction('UPDATE_TICKET_LOG_SUCCESS', data => data);
const updateTicketLogsError = createAction('UPDATE_TICKET_LOG_ERROR');

// Delete Ticket log action
const deleteTicketLogsRequest = createAction('DELETE_TICKET_LOG_REQUEST', data => data);
const deleteTicketLogsSuccess = createAction('DELETE_TICKET_LOG_SUCCESS', data => data);
const deleteTicketLogsError = createAction('DELETE_TICKET_LOG_ERROR');

// create Ticket Setting action
const createTicketSettingRequest = createAction('CREATE_TICKET_SETTING_REQUEST', data => data);
const createTicketSettingSuccess = createAction('CREATE_TICKET_SETTING_SUCCESS', data => data);
const createTicketSettingError = createAction('CREATE_TICKET_SETTING_ERROR');

// get Ticket Setting action
const getTicketSettingRequest = createAction('GET_TICKET_SETTING_REQUEST', data => data);
const getTicketSettingSuccess = createAction('GET_TICKET_SETTING_SUCCESS', data => data);
const getTicketSettingError = createAction('GET_TICKET_SETTING_ERROR');

// get Ticket Setting  action
const getAllTicketSettingRequest = createAction('GET_ALL_TICKET_SETTING_REQUEST', data => data);
const getAllTicketSettingSuccess = createAction('GET_ALL_TICKET_SETTING_SUCCESS', data => data);
const getAllTicketSettingError = createAction('GET_ALL_TICKET_SETTING_ERROR');

// Update Ticket Setting action
const updateTicketSettingRequest = createAction('UPDATE_TICKET_SETTING_REQUEST', data => data);
const updateTicketSettingSuccess = createAction('Update_TICKET_SETTING_SUCCESS', data => data);
const updateTicketSettingError = createAction('Update_TICKET_SETTING_ERROR');

// Delete Ticket Setting action
const deleteTicketSettingRequest = createAction('DELETE_TICKET_SETTING_REQUEST', data => data);
const deleteTicketSettingSuccess = createAction('DELETE_TICKET_SETTING_SUCCESS', data => data);
const deleteTicketSettingError = createAction('DELETE_TICKET_SETTING_ERROR');


// create Help Desk action
const createHelpDeskRequest = createAction('CREATE_HELP_DESK_REQUEST', data => data);
const createHelpDeskSuccess = createAction('CREATE_HELP_DESK_SUCCESS', data => data);
const createHelpDeskError = createAction('CREATE_HELP_DESK_ERROR');

// get Help Desk action
const getHelpDeskRequest = createAction('GET_HELP_DESK_REQUEST', data => data);
const getHelpDeskSuccess = createAction('GET_HELP_DESK_SUCCESS', data => data);
const getHelpDeskError = createAction('GET_HELP_DESK_ERROR');

// get Help Desk  action
const getAllHelpDeskRequest = createAction('GET_ALL_HELP_DESK_REQUEST', data => data);
const getAllHelpDeskSuccess = createAction('GET_ALL_HELP_DESK_SUCCESS', data => data);
const getAllHelpDeskError = createAction('GET_ALL_HELP_DESK_ERROR');

// Update Help Desk action
const updateHelpDeskRequest = createAction('UPDATE_HELP_DESK_REQUEST', data => data);
const updateHelpDeskSuccess = createAction('Update_HELP_DESK_SUCCESS', data => data);
const updateHelpDeskError = createAction('Update_HELP_DESK_ERROR');

// Delete Help Desk action
const deleteHelpDeskRequest = createAction('DELETE_HELP_DESK_REQUEST', data => data);
const deleteHelpDeskSuccess = createAction('DELETE_HELP_DESK_SUCCESS', data => data);
const deleteHelpDeskError = createAction('DELETE_HELP_DESK_ERROR');

// Get Ticket Summary action
const getTicketSummaryRequest = createAction('GET_TICKET_SUMMARY_REQUEST', data => data);
const getTicketSummarySuccess = createAction('GET_TICKET_SUMMARY_SUCCESS', data => data);
const getTicketSummaryError = createAction('GET_TICKET_SUMMARY_ERROR');


// clear existing Ticket action
const handleClearTicketStore = createAction('HANDLE_CLEAR_Ticket_STORE', data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    createTicketRequest,
    createTicketSuccess,
    createTicketError,

    getTicketRequest,
    getTicketSuccess,
    getTicketError,

    getAllTicketRequest,
    getAllTicketSuccess,
    getAllTicketError,

    updateTicketRequest,
    updateTicketSuccess,
    updateTicketError,

    deleteTicketRequest,
    deleteTicketSuccess,
    deleteTicketError,

    createTicketIssueTypeRequest,
    createTicketIssueTypeSuccess,
    createTicketIssueTypeError,

    getAllTicketTypeRequest,
    getAllTicketTypeSuccess,
    getAllTicketTypeError,

    getTicketIssueSubTypeRequest,
    getTicketIssueSubTypeSuccess,
    getTicketIssueSubTypeError,

    getAllTicketIssueTypeRequest,
    getAllTicketIssueTypeSuccess,
    getAllTicketIssueTypeError,

    updateTicketTypeRequest,
    updateTicketTypeSuccess,
    updateTicketTypeError,

    deleteTicketTypeRequest,
    deleteTicketTypeSuccess,
    deleteTicketTypeError,

    createTicketLogsRequest,
    createTicketLogsSuccess,
    createTicketLogsError,

    getAllTicketLogsRequest,
    getAllTicketLogsSuccess,
    getAllTicketLogsError,

    getTicketLogsRequest,
    getTicketLogsSuccess,
    getTicketLogsError,

    updateTicketLogsRequest,
    updateTicketLogsSuccess,
    updateTicketLogsError,

    deleteTicketLogsRequest,
    deleteTicketLogsSuccess,
    deleteTicketLogsError,

    createTicketSettingRequest,
    createTicketSettingSuccess,
    createTicketSettingError,

    getTicketSettingRequest,
    getTicketSettingSuccess,
    getTicketSettingError,

    getAllTicketSettingRequest,
    getAllTicketSettingSuccess,
    getAllTicketSettingError,

    updateTicketSettingRequest,
    updateTicketSettingSuccess,
    updateTicketSettingError,

    deleteTicketSettingRequest,
    deleteTicketSettingSuccess,
    deleteTicketSettingError,

    createHelpDeskRequest,
    createHelpDeskSuccess,
    createHelpDeskError,

    getHelpDeskRequest,
    getHelpDeskSuccess,
    getHelpDeskError,

    getAllHelpDeskRequest,
    getAllHelpDeskSuccess,
    getAllHelpDeskError,

    updateHelpDeskRequest,
    updateHelpDeskSuccess,
    updateHelpDeskError,

    deleteHelpDeskRequest,
    deleteHelpDeskSuccess,
    deleteHelpDeskError,

    getTicketSummaryRequest,
    getTicketSummarySuccess,
    getTicketSummaryError,

    handleClearTicketStore,
    // toastMsgAction,

}